import { PermissionsRoute as PrivateRoute } from './PermissionsRoute';

export { PrivateRoute };

export default PrivateRoute;
